import { I18nComponente } from "@/types/gerais"

export const OTabelaAcordeaoProjetosi18n: I18nComponente = {
  "pt-BR": {
    nome: "nome",
    pesquisarPorNome: "pesquisar por nome",
    codigo: "código",
    pesquisarPorCodigo: "pesquisar por código",
    arquivar: "arquivar",
  },
  "es-CO": {
    nome: "nombre",
    pesquisarPorNome: "buscar por nombre",
    codigo: "código",
    pesquisarPorCodigo: "buscar por código",
    arquivar: "archivar",
  },
}
